<template>
  <div class="invoice-related invoice-related-time">
    <div v-if="totalItems" class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>DATE</th>
            <th>CATEGORY</th>
            <th>ITEM</th>
            <th>STAFF</th>
            <th>QTY/HOURS</th>
            <th>COST</th>
            <th>SELL</th>
            <th width="120" class="text-right">MOVE TO INVOICE</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in relatedItems" :key="index">
            <td>{{ item.session_date | toHumanDate }}</td>
            <td>{{ item.cost?item.cost.category.name:'' }}</td>
            <td>{{ item.cost?item.cost.description:'' }}</td>
            <td>{{ item.user.full_name }}</td>
            <td>{{ item.duration }}</td>
            <td>${{ item.user.cost_rate }}</td>
            <td>${{ item.user.billable_rate }}</td>
            <td align="right">
              <a v-if="!item.invoiced" href="javascript:;" class="icon-down-arrow" v-tooltip="'Move'" @click="moveToInvoice(index, item.id)"></a>
              <span v-else class="icon-checkmark"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 v-else><span v-if="state==''">No related time items.</span></h4>
  </div>
</template>


<script>
  import {mapGetters} from 'vuex'
  import ServiceInvoice from '@/services/invoice'
  export default {
    data () {
      return {
        state: '',
        relatedItems: [],
        totalItems: 0
      }
    },
    props: ['reload'],
    watch: {
      reload: 'init'
    },
    computed: {
      ...mapGetters(['INVOICE']),
    },
    created () {},
    mounted () {
      this.init();
    },
    methods: {
      init () {
        this.getApprovedItems();
      },
      getApprovedItems () {
        let self = this;
        if (!self.INVOICE.job_id)
          return [];

        let params = {
          job_id: self.INVOICE.job_id
        };
        self.state = 'loading';
        ServiceInvoice.getTimesheet(self.INVOICE.id, params, resp => {
          self.state = '';
          self.relatedItems = resp;
          self.totalItems = window.numkeys(self.relatedItems);
        });
      },
      moveToInvoice (index, item_id) {
        let self = this;
        ServiceInvoice.moveItemToInvoice(self.INVOICE.id, {type: 'time', id: item_id}, addedInvoiceItem => {
          self.$notify({
            type: 'success',
            text: 'Timesheet record moved successfully'
          });
          self.$emit('item-saved', addedInvoiceItem, -1);
          self.relatedItems[index].invoiced = true;
        });
      }
    }
  }
</script>
